export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9109.67ce7992.jpg";